import * as actions from "Actions";
import * as api from "Api";

export const fetchAnnexeCategorySuggestions = ({
  searchWord,
  lng,
  enabled
}) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    const { backOffice } = getState().params;

    return dispatch(
      actions.getAnnexeCategorySuggestions(
        api.getAnnexeCategories(backOffice, uen, lng, searchWord, enabled)
      )
    );
  };
};

export const fetchEnabledAnnexeCategories = ({ lng }) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    const { backOffice } = getState().params;

    return dispatch(
      actions.getEnabledAnnexeCategories(
        api.getAnnexeCategories(backOffice, uen, lng, "", 1)
      )
    );
  };
};

export const fetchAnnexeCategories = () => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    const { backOffice } = getState().params;

    return dispatch(
      actions.getAnnexeCategories(api.getAnnexeCategories(backOffice, uen))
    );
  };
};

export const updateAnnexeCategoriesState = () => (dispatch, getState) => {
  const {
    annexeCategories: { modified },
    auth: { currentOrganization }
  } = getState();

  return dispatch(
    actions.updateAnnexeCategoriesState(
      api.updateAnnexeCategoriesState({
        uen: currentOrganization.uen,
        categories: modified
      })
    )
  );
};

export const updateAnnexeCategory = (
  categoryId,
  labels,
  selectedAccount,
  type
) => (dispatch, getState) => {
  const {
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.updateAnnexeCategory(
      api.updateAnnexeCategory({
        uen: currentOrganization.uen,
        id: categoryId,
        labels: labels,
        associatedAccount: selectedAccount,
        type: type,
        backOffice: backOffice
      })
    )
  );
};

export const deleteAnnexeCategory = categoryId => (dispatch, getState) => {
  const {
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.deleteAnnexeCategory(
      api.deleteAnnexeCategory({
        uen: currentOrganization.uen,
        id: categoryId,
        backOffice: backOffice
      })
    )
  );
};

export const saveAnnexeCategory = (labels, selectedAccount) => (
  dispatch,
  getState
) => {
  const {
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.saveAnnexeCategory(
      api.saveAnnexeCategory({
        uen: currentOrganization.uen,
        labels: labels,
        associatedAccount: selectedAccount,
        backOffice: backOffice
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/annexeCategory.js